/**
 * 管理者画面の共通処理スクリプトのエントリーファイル
 */
require('../bootstrap');
require('./pages/common.js');
require('./lib/html5/html5.js');
require('remodal');
